import { render } from "./SVGAR.vue?vue&type=template&id=db99936e"
import script from "./SVGAR.vue?vue&type=script&lang=js"
export * from "./SVGAR.vue?vue&type=script&lang=js"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__